<div class="xWrapper">
  <div class="notificationWrapper">
    <div class="notification-header">
      <div class="iconWithTextHeader">
        <mat-icon class="notificationIcon stroke" svgIcon={{icon}}></mat-icon>
        <div class="notification-title">{{title}}</div>
      </div>
    </div>

    <div class="dialog-content" style="padding: 0">
      <div class="content-msg" [innerHTML]="message"></div>
    </div>

    <div class="notification-footer">
      <div>
        @if (dontShowAgain !== undefined) {
          <ins-checkbox [label]="''" [checkboxText]="'Don\'t show again'" [(value)]="dontShowAgain" [topPad]="false"></ins-checkbox>
        }
      </div>
      <div class="notification-buttons">
        @for (button of buttonsInfo; track $index; let i = $index) {
          <button
            class="actionButton minWidth"
            [class.customBorder]="i !== (buttonsInfo.length - 1)"
            [class.white]="i !== (buttonsInfo.length - 1)"
            [ngClass]="i === (buttonsInfo.length - 1) ? colorScheme : null"
            (click)="close(button.value)">
            {{ button.displayValue }}
          </button>
        }
      </div>
    </div>
  </div>
  <mat-icon class="iconClose" svgIcon="dialog.close" (click)="close(onXAction)"></mat-icon>
</div>

